import { Devices } from "../constants";
import { SettingsItem } from "./SettingsItem";

const { IPHONE_10 } = Devices;

const Device = ({
  disabled = false,
  id = null,
  name = "",
  onClick = () => null,
  selected = false,
}) => (
  <div
    className={`
    rounded-lg
    border
    ${selected ? "border-gray-600" : "border-gray-100"}
    h-36
    ${disabled ? "bg-gray-100" : "cursor-pointer"}
    flex
    items-center
    justify-center
  `}
    onClick={onClick}
  >
    {id ? (
      <img
        src={`/images/icons/devices/${id}.svg`}
        alt={name}
        className="w-1/2 max-w-max"
      />
    ) : null}
  </div>
);

const devices = [
  {
    id: IPHONE_10,
  },
  {
    id: "disabled-1",
    disabled: true,
  },
  {
    id: "disabled-2",
    disabled: true,
  },
];

export const DeviceSetting = ({
  className = "",
  onChange = () => false,
  value = null,
}) => {
  return (
    <SettingsItem title="Device" className={className}>
      <div className="grid grid-cols-3 gap-4 pt-2">
        {devices.map((device) => (
          <Device
            key={device.id}
            onClick={device.disabled ? null : () => onChange(device.id)}
            selected={value === device.id}
            {...device}
          />
        ))}
      </div>
    </SettingsItem>
  );
};
